/* 상품 상세 — 선택한 상품 요약 표의 금액 갱신.
   카페24 `#totalProducts` + `.total` 에 대응한다(마크업은 `snippets/buy-buttons.liquid`).

   하는 일은 하나다: 수량이 바뀌면 **행 금액**과 **합계**, **(N item(s))** 문구를 다시 쓴다.

   ⚠️⚠️ **통화 기호·문구를 이 파일에 적지 말 것.** 몰마다 통화가 다르고(USD/GBP/EUR) 문구는
      번역 대상이다. 단가(`data-unit-price`, 최소 단위 정수) · 통화 코드(`data-currency`) ·
      문구 틀(`data-count-text`, `__N__` 자리표시자)을 Liquid 가 넘긴다.
   ⚠️ 첫 로드에서도 한 번 갱신한다 — Liquid 의 `money` 와 `Intl` 의 표기가 미세하게 다를 수
      있어(예: `US$` 접두) 수량을 바꾼 순간 형식이 튀는 것을 막는다. 둘 중 하나로 통일한다.
   ⚠️ `quantity-input` 의 `+/-` 버튼은 `input` 이벤트를 발생시키므로 그것만 들으면 된다.
      버튼 클릭을 따로 듣지 말 것 — 두 번 계산된다. */
(() => {
  const fmt = (minor, currency) => {
    const amount = minor / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (e) {
      // 통화 코드가 비었거나 알 수 없을 때 — 숫자만이라도 보여 준다.
      return amount.toFixed(2);
    }
  };

  const wire = (root) => {
    const input = root.querySelector('.quantity__input');
    if (!input) return;

    const unit = parseInt(root.dataset.unitPrice, 10);
    if (!Number.isFinite(unit)) return;
    const currency = root.dataset.currency;
    const countText = root.dataset.countText || '';

    const line = root.querySelector('[data-nt-osum-line]');
    // 합계 줄은 표 **바깥**에 있다(카페24도 그렇다) — 형제에서 찾는다.
    const summary = root.nextElementSibling;
    const total = summary && summary.querySelector('[data-nt-osum-total]');
    const count = summary && summary.querySelector('[data-nt-osum-count]');

    const render = () => {
      const n = Math.max(1, parseInt(input.value, 10) || 1);
      const money = fmt(unit * n, currency);
      if (line) line.textContent = money;
      if (total) total.textContent = money;
      if (count) count.textContent = countText.replace('__N__', String(n));
    };

    input.addEventListener('input', render);
    input.addEventListener('change', render);
    render();
  };

  const init = () => document.querySelectorAll('[data-nt-osum]').forEach(wire);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ⚠️ variant 를 바꾸면 Dawn 이 섹션을 다시 그린다 — 그때 이 스크립트는 이미 실행이 끝나
     새 마크업에 배선이 없다. 그래서 섹션 교체를 감지해 다시 건다.
     ⚠️ 지금 상품은 variant 가 1개씩이라(실측) 실제로 발생하지 않지만, 나중에 옵션이 생긴
        상품에서 금액이 굳어 버리는 것을 막는 안전장치다. */
  new MutationObserver((records) => {
    for (const r of records) {
      for (const node of r.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-nt-osum]')) wire(node);
        else if (node.querySelectorAll) node.querySelectorAll('[data-nt-osum]').forEach(wire);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
